<script lang="ts">import WelcomeModalDesktopIllustration from "../images/welcome-modal-desktop-illustration.svg";
import WelcomeModalMobileIllustration from "../images/welcome-modal-mobile-illustration.svg";
import { Button } from "@infinitro/button";
import { t, Verbiage } from "@infinitro/content";
import { closeThisModal, isMobile, ModalDialog, modalStack, stateOpenModal } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { Text } from "@infinitro/text";
import { derived } from "svelte/store";
const thisModal = ModalDialog.WelcomeModal;
const closeModal = () => closeThisModal(thisModal);
const modalIndex = derived(modalStack, ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal));
const isModalOpen = derived(modalIndex, ($modalIndex) => $modalIndex >= 0);
const payload = derived(modalStack, ($modalStack) => $modalStack.find((e) => e.modal === thisModal)?.data);
const zOverlay = derived(modalIndex, ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999);
export const closeWelcomeModal = () => {
	closeThisModal(ModalDialog.WelcomeModal);
};
</script>

{#if $stateOpenModal === ModalDialog.WelcomeModal}
	<div class="welcome-modal">
		<Modal
			title={$isMobile ? $t(Verbiage.welcome_modal_title) : ''}
			width="600px"
			height="524px"
			{closeModal}
			isPurple={true}
			padding={!isMobile ? '0px' : ''}
			showCloseButton={$isMobile}
			zIndexOverlay={$zOverlay}
			zIndexUnderlay={$zOverlay - 1}
		>
			<div class="welcome-modal-illustrations">
				{#if $isMobile}
					<img
						src={WelcomeModalMobileIllustration}
						alt={$t(Verbiage.welcome_modal_illustration_alt, 'alts')}
						class="welcome-modal-illustration-mobile"
					/>
				{:else}
					<img
						src={WelcomeModalDesktopIllustration}
						alt={$t(Verbiage.welcome_modal_illustration_alt, 'alts')}
						class="welcome-modal-illustration-desktop"
					/>
				{/if}
			</div>

			<div class="welcome-modal-content">
				<div class="welcome-modal-subtitle">
					<div class="welcome-modal-subtitle-first-part">
						<Text
							type="body"
							bodyWeight="bold"
							customStyle="color: #FFCE2B !important; font-size: 41px !important; line-height: 44px !important;"
							textAlign="center"
							fontFamily="alternative-2"
						>
							{$t(Verbiage.welcome_modal_subtitle_first_part)}
						</Text>
					</div>

					<div class="welcome-modal-subtitle-second-part">
						<Text
							type="body"
							bodyWeight="bold"
							customStyle=" font-size: 59px !important; line-height: 57px !important;"
							textColor="white"
							textAlign="center"
							fontFamily="alternative-2"
						>
							{$t(Verbiage.welcome_modal_subtitle_second_part)}
						</Text>
					</div>
				</div>

				<div class="welcome-modal-description">
					<Text
						type="body"
						textAlign="center"
						customStyle="line-height: 16px;"
						bodyWeight={$isMobile ? 'regular' : 'bold'}
					>
						{$t(Verbiage.welcome_modal_description)}
					</Text>
				</div>

				<div class="welcome-modal-button-container">
					<Button onClick={() => closeWelcomeModal()} fullWidth>
						<Text>
							{$t(Verbiage.welcome_modal_button_text)}
						</Text>
					</Button>
				</div>
			</div>
		</Modal>
	</div>
{/if}

<style>
	.welcome-modal {
		background: linear-gradient(180deg, #2b085f 0%, #663da2 100%);
	}

	.welcome-modal-illustration-mobile,
	.welcome-modal-illustration-desktop {
		position: absolute;
		left: 0px;
		width: 100%;
		min-width: 100%;
}

	.welcome-modal-illustration-mobile {
		top: -4.063rem;
}

	.welcome-modal-illustration-desktop {
		top: -0.188rem;
		border-radius: 1.5rem;
}

	.welcome-modal-content {
		position: absolute;
		left: 0px;
		width: 100%;
		min-width: 100%;
		top: calc(50vh - 7.5rem);
}

	.welcome-modal-subtitle-first-part,
	.welcome-modal-subtitle-second-part {
		text-transform: uppercase;
}

	.welcome-modal-description {
		left: 0px;
		margin-top: 1.25rem;
		margin-bottom: 1.25rem;
		padding-left: 1rem;
		padding-right: 1rem;
}

	.welcome-modal-button-container {
		width: 100%;
		min-width: 100%;
		padding-left: 1rem;
		padding-right: 1rem;
}

	@media (min-width: 768px) {
		.welcome-modal-content {
			top: 68vh;
		}
	}

	@media (min-width: 1024px) {
		.welcome-modal-content {
			top: 14rem;
		}
	}
</style>
